// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-recs {
    width: 100%;
    /* border-bottom: 1px solid #bbb; */
    border-top: 1px solid gray;
    /* border-left: 1px solid gray; */
    /* border-right: 1px solid gray; */
    border-radius: 10px;
    padding: 0px 0px 10px 0px;
    margin-top: 20px;;
    /* padding: 10px 10px 10px 10px; */
    /* background-color: #f0f0f0; */
}

.audit-recs-with-data {

    border-bottom: 1px solid #bbb;
    border-left: 1px solid gray; 
    border-right: 1px solid gray; 
}

.audit-recs-toolbar {
    border-bottom: 1px solid #787878;
    border-left: 1px solid gray;
    border-right: 1px solid gray;
    background-color: #f0f0f0;
    border-radius: 10px;
    padding: 10px 15px 10px 15px;
}

.audit-recs-icon {
    margin-right: 5px;;
}

.audit-recs-attr {
    /* color: blue; */
    font-weight: 700;
    /* word-wrap: break-word !important; */
    /* font-size: 0.8em; */
}

.audit-recs-old {
    color: gray;
    font-weight: 700;
    /* font-size: 0.8em; */
}

.audit-recs-new {
    color: black;
    font-weight: 700;
    /* font-size: 0.8em; */
}

/* span {
    white-space:nowrap;
} */

.audit-recs-td {
    font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/components/AuditList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mCAAmC;IACnC,0BAA0B;IAC1B,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;AACpB","sourcesContent":[".audit-recs {\n    width: 100%;\n    /* border-bottom: 1px solid #bbb; */\n    border-top: 1px solid gray;\n    /* border-left: 1px solid gray; */\n    /* border-right: 1px solid gray; */\n    border-radius: 10px;\n    padding: 0px 0px 10px 0px;\n    margin-top: 20px;;\n    /* padding: 10px 10px 10px 10px; */\n    /* background-color: #f0f0f0; */\n}\n\n.audit-recs-with-data {\n\n    border-bottom: 1px solid #bbb;\n    border-left: 1px solid gray; \n    border-right: 1px solid gray; \n}\n\n.audit-recs-toolbar {\n    border-bottom: 1px solid #787878;\n    border-left: 1px solid gray;\n    border-right: 1px solid gray;\n    background-color: #f0f0f0;\n    border-radius: 10px;\n    padding: 10px 15px 10px 15px;\n}\n\n.audit-recs-icon {\n    margin-right: 5px;;\n}\n\n.audit-recs-attr {\n    /* color: blue; */\n    font-weight: 700;\n    /* word-wrap: break-word !important; */\n    /* font-size: 0.8em; */\n}\n\n.audit-recs-old {\n    color: gray;\n    font-weight: 700;\n    /* font-size: 0.8em; */\n}\n\n.audit-recs-new {\n    color: black;\n    font-weight: 700;\n    /* font-size: 0.8em; */\n}\n\n/* span {\n    white-space:nowrap;\n} */\n\n.audit-recs-td {\n    font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
